import { cn } from 'lib/helpers/utility';

const PayOnlineButton = ({ className = 'self-end', disabled = false }) => {
  return (
    <div
      className={cn(
        'payment-button-submit-wrapper flex items-center',
        disabled && 'pointer-events-none opacity-50',
        className
      )}
      aria-disabled={disabled || undefined}
      {...(disabled && { inert: '' })}>
      <div
        className="card-submit submit-button payroc-card-submit-button h-8"
        tabIndex={disabled ? -1 : undefined}
      />
    </div>
  );
};

export default PayOnlineButton;
